import urlTemplate from 'url-template';
import type {
  NetworkPointsResponse,
  NetworkPointsParams,
} from 'src/apis/network-points/types';
import type { NetworkPointsRootRequest } from 'src/apis/network-points/use-network-points-root';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

type Options = {
  params: NetworkPointsParams;
  networkPointsRoot: Successful<NetworkPointsRootRequest>;
};

export function useNetworkPoints() {
  const networkPoints = useAxios(
    (axios, baseConfig, { networkPointsRoot, params }: Options) => {
      const link = networkPointsRoot.response.data._links.getNetworkPoints.href;
      return axios.request<NetworkPointsResponse>({
        ...baseConfig,
        url: urlTemplate.parse(link).expand({}),
        params,
      });
    },
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isConstraintViolation(error)) return error;
        throw error;
      },
    }
  );

  return networkPoints;
}

export type NetworkPointsRequest = ReturnType<typeof useNetworkPoints>;
